import { createIcon } from "@chakra-ui/react";
import React from "react";

export const AiChatIcon = createIcon({
  displayName: "AiChatIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        d="M2.25 12.7593C2.25 14.3604 3.37341 15.754 4.95746 15.987C6.04357 16.1467 7.14151 16.27 8.25 16.3556V21L12.326 16.924C12.6017 16.6483 12.9738 16.4919 13.3635 16.481C15.2869 16.4274 17.1821 16.2606 19.0425 15.9871C20.6266 15.7542 21.75 14.3606 21.75 12.7595V6.74056C21.75 5.13946 20.6266 3.74583 19.0425 3.51293C16.744 3.17501 14.3926 3 12.0003 3C9.60776 3 7.25612 3.17504 4.95747 3.51302C3.37342 3.74593 2.25 5.13956 2.25 6.74064V12.7593Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2589 12.3546L12 13.3901L11.7411 12.3546C11.4388 11.1454 10.4947 10.2012 9.28546 9.89894L8.25 9.64008L9.28546 9.38121C10.4947 9.07891 11.4388 8.13475 11.7411 6.92554L12 5.89008L12.2589 6.92554C12.5612 8.13475 13.5053 9.07891 14.7145 9.38121L15.75 9.64008L14.7145 9.89894C13.5053 10.2012 12.5612 11.1454 12.2589 12.3546Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  defaultProps: {
    color: "currentColor",
  },
});
